module.exports = function() {
  var stream = this._stream;
  return new Promise(function(resolve) {
    if (stream.destroyed) return resolve();
    stream.once("close", resolve).destroy();
  });
};



//////////////////
// WEBPACK FOOTER
// ../~/stream-source/cancel.js
// module id = 1677
// module chunks = 2